(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    const root = document.documentElement;
    let frameId = 0;

    const replaceHomepageLogoHeading = () => {
      if (!document.querySelector('.bpc-v7')) return;
      const heading = document.querySelector('h1.header__heading');
      if (!heading) return;

      const replacement = document.createElement('div');
      [...heading.attributes].forEach((attribute) => {
        replacement.setAttribute(attribute.name, attribute.value);
      });
      while (heading.firstChild) replacement.appendChild(heading.firstChild);
      heading.replaceWith(replacement);
    };

    const getVisibleHeaderBottom = () => {
      const candidates = [
        ...document.querySelectorAll(
          '.shopify-section-group-header-group, .section-header, sticky-header, .bpc-market-bar'
        )
      ];
      let bottom = 0;

      candidates.forEach((element) => {
        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        const visible =
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          rect.height > 0 &&
          rect.bottom > 0;
        const stickyLike =
          style.position === 'sticky' ||
          style.position === 'fixed' ||
          element.classList.contains('shopify-section-header-sticky') ||
          rect.top <= 1;

        if (visible && stickyLike && rect.top < window.innerHeight) {
          bottom = Math.max(bottom, Math.min(rect.bottom, window.innerHeight));
        }
      });

      return Math.max(0, Math.round(bottom));
    };

    const updateMeasurements = () => {
      frameId = 0;
      root.style.setProperty('--bpc-ui-stack-height', `${getVisibleHeaderBottom()}px`);

      const rail = document.querySelector('[data-bpc-collection-rail-shell]');
      const railHeight = rail ? Math.round(rail.getBoundingClientRect().height) : 0;
      root.style.setProperty('--bpc-collection-rail-height', `${Math.max(0, railHeight)}px`);
    };

    const scheduleMeasurements = () => {
      if (frameId) return;
      frameId = window.requestAnimationFrame(updateMeasurements);
    };

    replaceHomepageLogoHeading();

    document.querySelectorAll('[data-bpc-rail-control]').forEach((button) => {
      button.addEventListener('click', () => {
        const targetId = button.getAttribute('data-bpc-rail-control');
        const direction = button.getAttribute('data-direction') === 'prev' ? -1 : 1;
        const rail = document.getElementById(targetId);
        if (!rail) return;

        rail.scrollBy({
          left: direction * Math.max(220, Math.round(rail.clientWidth * .78)),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
    });

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(scheduleMeasurements);
      document
        .querySelectorAll('.shopify-section-group-header-group, .section-header, sticky-header, .bpc-market-bar, [data-bpc-collection-rail-shell]')
        .forEach((element) => observer.observe(element));
    }

    window.addEventListener('resize', scheduleMeasurements, { passive: true });
    window.addEventListener('orientationchange', scheduleMeasurements, { passive: true });
    window.addEventListener('scroll', scheduleMeasurements, { passive: true });
    document.addEventListener('shopify:section:load', scheduleMeasurements);

    scheduleMeasurements();
  });
})();
